import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CollegePageContainer from "../Container/CollegePageContainer";
import { Button, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField } from "@mui/material";
import { API } from "../../API";
import moment from "moment";
import debounce from 'lodash/debounce';
import { statusInvoice } from "../../Helper";
import { APIMETHOD } from "../../v2/API";
import { customer } from "../../v2/endpoints/customer";
import FormControlInput from "../../Components/FormControl/FormControl";
import { Oval } from "react-loader-spinner";

const InvoiceTable = (props) => {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const user = JSON.parse(JSON.parse(window.localStorage['persist:root']).college)?.user;
    const campuses = JSON.parse(JSON.parse(window.localStorage['persist:root']).college)?.campuses;
    const [filterOption, setFilterOption] = useState({ campus: "", period_date: "", duo_date: "", approver: "", invoice_ref: "", status: "" });
    const [paymentDate, setPaymentDate] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const onChangeValue = debounce((key, value) => {
        const newValue = {
            ...filterOption,
            [key]: value
        }
        setFilterOption(newValue)
    }, 0);
    const [approver, setApprover] = useState([]);

    useEffect(() => {
        let is_personnel = user?.personnel_id ? true : false;
        getInvoices(1, pageSize, filterOption, is_personnel);
        fetchPaymentDate();
        const customer_id = user.institution_id ? user.institution_id : user.institution;
        APIMETHOD.get(`${customer.fetchApproverForInvoices}/${customer_id}`).then(result => {
            setApprover(result?.data);
        });
    }, []);

    const getInvoices = (page, limit, filterOption, is_personnel) => {
        setIsLoading(true);
        API.getListInvoices(page, limit, user?.customer_id || user?.personnel_id, filterOption, is_personnel, user?.institution_id || user?.institution).then(result => {
            setData(result.data.data);
            setTotalRecords(result.data.paginate.total_record);
            setIsLoading(false);
            // setPageCount(result.data.paginate.total_page);
        })
    }

    const fetchPaymentDate = () => {
        APIMETHOD.get(customer.fetchPaymentDate, {}).then(result => {
            const sortedDates = [...result?.data]?.sort((a, b) => {
                const momentA = moment(a.fortnight_end_date, 'DD/MM/YYYY');
                const momentB = moment(b.fortnight_end_date, 'DD/MM/YYYY');
                return momentB - momentA;
            });
            setPaymentDate(sortedDates);
        });
    }

    const CampusCell = ({ campuses }) => (
        <div className="can-deliver-cell-container">
            {campuses?.map((campus, index) => (
                <div key={index} className="can-deliver-cell-child-element">
                    {campus.campus_shortname + ' - ' + campus.suburb}
                </div>
            ))}
        </div>
    );

    const handleFilter = () => {
        const keys = Object.keys(filterOption)
        keys.forEach(key => {
            if (filterOption[key] === '') filterOption[key] = null
        })
        let is_personnel = user?.personnel_id ? true : false;
        getInvoices(1, 10, filterOption, is_personnel);
    }

    const clearFilter = () => {
        const keys = Object.keys(filterOption)
        keys.forEach(key => {
            filterOption[key] = ''
        })
        let is_personnel = user?.personnel_id ? true : false;
        getInvoices(1, 10, filterOption, is_personnel);
    }

    const handleChangeRowsPerPage = (event) => {
        setPageSize(parseInt(event.target.value, 10));
        let is_personnel = user?.personnel_id ? true : false;
        getInvoices(1, parseInt(event.target.value, 10), filterOption, is_personnel);
        setCurrentPage(0);
    };

    const handleChangePage = (event, newPage) => {
        let is_personnel = user?.personnel_id ? true : false;
        getInvoices(newPage + 1, pageSize, filterOption, is_personnel);
        setCurrentPage(newPage);
    };

    return (
        <CollegePageContainer
            user={props.user}
            header="Invoice Page"
        >
            <Paper sx={{ width: '100%', mb: 2 }}>
                <FormControlInput
                    inputLabel={"Campus"}
                    label={"Campus"}
                    value={filterOption.campus}
                    onChange={event => onChangeValue("campus", event.target.value)}
                >
                    <MenuItem value="">
                    </MenuItem>
                    {
                        campuses && campuses.map(item => {
                            return <MenuItem value={item._id}>{item.campus_shortname + ' - ' + item.suburb}</MenuItem>
                        })
                    }
                </FormControlInput>
                <FormControlInput
                    inputLabel={"Period"}
                    label={"Period"}
                    value={filterOption.period_date}
                    onChange={event => onChangeValue("period_date", event.target.value)}
                >
                    {
                        paymentDate && paymentDate.map(item => {
                            return <MenuItem value={item.fortnight_start_date + '-' + item.fortnight_end_date}>{item.fortnight_start_date + ' - ' + item.fortnight_end_date}</MenuItem>
                        })
                    }
                </FormControlInput>
                <FormControlInput
                    inputLabel={"Due"}
                    label={"Due"}
                    value={filterOption.duo_date}
                    onChange={event => onChangeValue("duo_date", event.target.value)}
                >
                    {
                        paymentDate && [...new Set(paymentDate.map(item => item.teachers_payment_date))].map(item => {
                            return <MenuItem value={item}>{item}</MenuItem>
                        })
                    }
                </FormControlInput>
                <FormControlInput
                    inputLabel={"Approver"}
                    label={"Approver"}
                    value={filterOption.approver}
                    onChange={event => onChangeValue("approver", event.target.value)}
                >
                    {
                        approver && approver.map(item => {
                            return <MenuItem value={item._id}>{item._id === user?.customer_id || item._id === user?.personnel_id ? 'Me' : item.first_name + item.last_name}</MenuItem>
                        })
                    }
                </FormControlInput>
                <FormControlInput
                    inputLabel={"Status"}
                    label={"Status"}
                    value={filterOption.status}
                    onChange={event => onChangeValue("status", event.target.value)}
                >
                    {
                        statusInvoice && statusInvoice.map(item => {
                            return <MenuItem value={item.name}>{item.name}</MenuItem>
                        })
                    }
                </FormControlInput>
                <Button onClick={handleFilter} sx={{ m: 1 }} className="btn-primary text-white" size="large" variant="outlined">Apply</Button>
                <Button onClick={clearFilter} sx={{ m: 1 }} size="large" variant="outlined">Clear Filter</Button>
                <TableContainer >
                    <Table
                        //   sx={{ minWidth: 750 }}
                        aria-labelledby="tableTitle"
                        size={'medium'}
                    >
                        <TableHead>
                            <TableRow>
                                {/* <TableCell width={10}>Invoice Number#</TableCell> */}
                                <TableCell width={10}>Invoice Ref#</TableCell>
                                <TableCell>Teaching Period</TableCell>
                                <TableCell>Due Date</TableCell>
                                <TableCell width={300}>Campus</TableCell>
                                {!user?.personnel_id ? <TableCell>Approver</TableCell> : ''}
                                <TableCell>Invoice Amount</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isLoading ?
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        <Oval
                                            height={80}
                                            width={80}
                                            color="#3bb4d8"
                                            visible={true}
                                            wrapperClass='justify-content-center'
                                            ariaLabel='oval-loading'
                                            secondaryColor="#3bb4d8"
                                            strokeWidth={2}
                                            strokeWidthSecondary={2}
                                        />
                                    </TableCell>
                                </TableRow>
                                : <>
                                    {data.length > 0 && data
                                        .map((item) => (
                                            <TableRow key={item._id}>
                                                {/* <TableCell>{item?.invoice_number}</TableCell> */}
                                                <TableCell>{item?.ref_id}</TableCell>
                                                <TableCell>{moment(item.invoice_period_start_date, 'YYYY-MM-DD').format("DD/MM/YYYY") + ' to ' + moment(item.invoice_period_end_date, 'YYYY-MM-DD').format("DD/MM/YYYY")}</TableCell>
                                                <TableCell>{moment(item.invoice_duo_date, 'YYYY-MM-DD').format("DD/MM/YYYY")}</TableCell>
                                                <TableCell>{<CampusCell campuses={item.campuses}></CampusCell>}</TableCell>
                                                {!user?.personnel_id ? <TableCell>{item?.personnel_id ? item?.personnel?.personnel_first_name + ' ' + item?.personnel?.personnel_last_name : 'Me'}</TableCell> : ''}
                                                <TableCell>{'$' + parseFloat(item.total_price).toFixed(2)}</TableCell>
                                                <TableCell>
                                                    {
                                                        item.status === 'Awaiting approval by manager'
                                                            ? 'Awaiting approval by ' + (item?.personnel_id ? (item?.personnel?.personnel_first_name + ' ' + item?.personnel?.personnel_last_name) : 'Me')
                                                            : item.status
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    <Link
                                                        className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
                                                        to={{ pathname: `/InvoiceDetails/${item._id}` }}
                                                    >
                                                        View
                                                    </Link>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    {data?.length === 0 && (
                                        <TableRow
                                            style={{
                                                height: 53,
                                            }}
                                        >
                                            <TableCell colSpan={7} />
                                        </TableRow>
                                    )}
                                </>}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={totalRecords}
                    rowsPerPage={pageSize}
                    page={currentPage}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </CollegePageContainer>
    );
}

export default InvoiceTable;